import "./ActiveOrders.css";
import OrderCard from "./OrderCard";

function ActiveOrders({ orders, onCancel }) {

    return (

        <div className="active-orders">

            <div className="active-orders-title">

                <h2>

                    Active Orders

                </h2>

                <span className="active-orders-count">

                    {orders.length} Orders

                </span>

            </div>

            {orders.map((order) => (

                <OrderCard
                    key={order._id}
                    order={order}
                    onCancel={onCancel}
                />

            ))}

        </div>

    );

}

export default ActiveOrders;